import { render } from "./SelectParty.vue?vue&type=template&id=31c2c6e8&ts=true"
import script from "./SelectParty.vue?vue&type=script&lang=ts"
export * from "./SelectParty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__